import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'




//DEACTIVATE A USER
const submit = (id) => client.delete(`auth/deactivate/${id}`);
export const useDeleteUser = (id) => useMutation(['deactivate',id],() => submit(id))